import { Component, OnInit } from '@angular/core';
import { AssetsManagementService } from '../../services/assets-management.service';
import { MasterDataService } from '../../services/master-data.service';
import * as moment from 'moment';
import { NgModel } from '@angular/forms';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-assets-transfer-history-report',
  templateUrl: './assets-transfer-history-report.component.html',
  styleUrls: ['./assets-transfer-history-report.component.css']
})
export class AssetsTransferHistoryReportComponent implements OnInit {
  selectType;
  selectBranch;
  reportList = [];
  branchList;
  selectDate;
  currentDate;
  isSerialTagSelect: Boolean;
  serialTagList;
  selectSerialTag;
  userRole;
  accessResponse: any;

  constructor(private assetsManagementService: AssetsManagementService,
    private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService) {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit(): void {
    this.selectType = 'Software';
    this.selectBranch = "null";
    // this.masterDataService.getBranch().subscribe((res) => {
    //   console.log('branchlist', res);
    //   this.branchList = res;
    // });
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  onTypeSelect() {
    this.reportList = [];
    this.showExcelButton = false;
  }

  onBranchSelect() {
    this.serialTagList = [];
    this.selectDate = undefined;
    this.reportList = [];
    this.showExcelButton = false;
    console.log('branch name', this.selectBranch);
    this.assetsManagementService.getServiceTagByBranch(this.selectBranch.id).subscribe((resp: any) => {
      console.log('service tag number by branch', resp);
      this.serialTagList = resp;
    })
  }

  onSelectSerialTag() {

  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isSerialTagSelect, false);
    this.isSerialTagSelect = !this.isSerialTagSelect;
  }

  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  getEmployeeName(data) {
    if (data.hardwareRest.release == true && data.user == null && data.tillDate == null) {
      return 'NA';
    } else {
      return 'Instock';
    }
  }

  setTillDate(data) {
    if (data.hardwareRest.retired == true && data.userRest != null && data.userRest.id == 54) {
      return 'Retired';
    } else if (data.hardwareRest.release == true && data.userRest == null) {
      return 'Discarded';
    } else {
      return 'NA';
    }
  }

  showExcelButton: boolean;
  changeSelectedDate2;
  onViewReport() {
    var serviceTagId = this.selectSerialTag.map(({ id }) => id);
    console.log('on view service tag number', serviceTagId);

    if (this.selectBranch == undefined || this.selectBranch == '' || this.selectBranch == 'null' ||
      this.selectDate == undefined) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select all fields.');
    } else {
      if (this.selectDate) {
        var changeSelectedDate1 = new Date(this.selectDate.year + '-' + this.selectDate.month + '-' + this.selectDate.day);
        this.changeSelectedDate2 = moment(changeSelectedDate1).format("YYYY-MM-DD");
      }
      if (this.selectType == 'Software') {
        this.assetsManagementService.transferSoftwareHistoryReport(this.selectBranch.id, this.changeSelectedDate2).subscribe((resp: any) => {
          console.log('software code', resp);
          this.reportList = resp;
          if (this.reportList.length > 0) {
            this.showExcelButton = true;
          } else {
            this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found');
            this.showExcelButton = false;
          }
        });
      } else {
        this.assetsManagementService.transferHardwareHistoryReport(this.selectBranch.id, this.changeSelectedDate2, serviceTagId).subscribe((resp: any) => {
          console.log('hardware code', resp);
          this.reportList = resp;
          if (this.reportList.length > 0) {
            this.showExcelButton = true;
          } else {
            this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found');
            this.showExcelButton = false;
          }
        });
      }
    }
  }

  onExportToExcelReport() {
    var serviceTagId = this.selectSerialTag.map(({ id }) => id);
    if (this.selectType == 'Software') {
      this.assetsManagementService.softwareHistoryReportExportToExcel(this.selectBranch.id, this.changeSelectedDate2).subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "TransferSoftwareHistoryReport.xlsx";
        link.click();
      });
    } else {
      this.assetsManagementService.hardwareHistoryReportExportToExcel(this.selectBranch.id, this.changeSelectedDate2, serviceTagId).subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "TransferHardwareHistoryReport.xlsx";
        link.click();
      });
    }
  }

  getRowSpanDetails(detailList) {
    var count = 0;
    detailList.assetReportRests.map((res) => {
      count++;
    });
    return count;
  }
}
